import React from 'react';
import styles from './ShareButton.scss';
import CSSModules from 'react-css-modules';

export interface Props {
  handleShareClick: () => void;
}

const ShareButton: React.StatelessComponent<Props> = ({ handleShareClick }) => {
  const handleShareButtonClick = () => {
    handleShareClick();
  };

  return (
    <button
      type="button"
      className="jg-btn"
      styleName="share-button"
      onClick={() => handleShareButtonClick()}
    >
      Share
    </button>
  );
};

export default CSSModules(ShareButton, styles, { allowMultiple: true });
